import TomSelect from 'tom-select';
import flatpickr from 'flatpickr';
import { Spanish } from 'flatpickr/dist/l10n/es.js';
import { registerPresenceControls } from '../../../../../profint.shared10/src/Profint.Shared.UI/assets/presence-controls.js';

registerPresenceControls(TomSelect, flatpickr, Spanish);
